var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Toolbar',{attrs:{"handle-reset":_vm.resetForm,"handle-submit":_vm.onSendForm}}),(_vm.item)?_c('TenantAccountSettingForm',{ref:"updateForm",attrs:{"errors":_vm.violations,"values":_vm.item,"refForm":"updateForm"}}):_vm._e(),_c('Loading',{attrs:{"visible":_vm.isLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }